export const bulkCancelJobRequest = {
  header: 'Cancel Job',
  jobSelector: {
    numberOfWorkersCancelled: '%workerCount% Wonoloer(s) will be canceled',
    description: {
      LTE: 'This Job is part of a Long-Term Engagement. You can cancel the entire Long-Term Engagement, in order to cancel and individual job, please request cancelation',
      LTO: 'This Job is part of a Long-Term Opportunity. You can cancel the entire Long-Term Engagement, in order to cancel and individual job, please request cancelation',
      RS: 'This job is part of a recurring shift. You can cancel the individual job or the entire recurring shift.'
    },
    cancelJobRequest: 'Cancel Job Request',
    bulkCancel: {
      LTE: 'Cancel entire Long-Term Engagement',
      LTO: 'Cancel entire Long-Term Opportunity',
      RS: 'Cancel entire Recurring Shift'
    }
  },
  reasonForm: {
    customReason: {
      label: 'Provide Reason',
      placeholder: 'Write reason...',
      error: 'Reason cannot be blank'
    },
    warningText: {
      LTE: 'Cancelling the entire LTE will result in cancelation fees worth 50% of the Wonoloer\'s pay, in accordance with Wonolo\'s Customer Agreement.',
      LTO: 'Cancelling the entire LTO will result in cancelation fees worth 50% of the Wonoloer\'s pay, in accordance with Wonolo\'s Customer Agreement.',
      RS: 'Cancelling the entire recurring shift will result in cancelation fees worth 50% of the Wonoloer\'s pay, in accordance with Wonolo\'s Customer Agreement.'
    },
    options: {
      laborNeedsChanged: 'My labor needs have changed',
      madeMistake: 'I made a mistake when posting job',
      other: 'Other'
    },
    longTermCancellationFriction: {
      label: 'Please type in CANCEL to confirm',
      error: 'Invalid input'
    },
    cancel: {
      bulk: {
        LTE: 'Cancel Long-Term Engagement',
        LTO: 'Cancel Long-Term Opportunity',
        RS: 'Cancel Recurring Shift'
      },
      single: {
        LTE: 'Cancel Job Request',
        LTO: 'Cancel Job Request',
        RS: 'Cancel Recurring Shift'
      }
    }
  },
  toastMessages: {
    emailRequest: {
      success: 'Long Term Job Request Canceled'
    },
    bulkCancel: {
      success: 'Recurring Shift Canceled'
    }
  }
};

export const bulkCancelJobRequestV2 = {
  header: 'Cancel Job',
  jobSelector: {
    numberOfWorkersCancelled: {
      partOne: '%workerCount% Wonoloers ',
      partTwo: 'will be canceled'
    },
    description: 'There are multiple days scheduled for this Job. If you would prefer to cancel all days rather than just this individual day, please click below:',
    cancelJobRequest: 'Cancel Single Day',
    bulkCancel: 'Cancel All Days'
  },
  reasonForm: {
    customReason: {
      label: 'Provide Reason',
      placeholder: 'Write reason...',
      error: 'Reason cannot be blank'
    },
    workdays: {
      title: '%workdays% workday',
      description: 'will be cancelled'
    },
    options: {
      laborNeedsChanged: 'My labor needs have changed',
      madeMistake: 'I made a mistake when posting job',
      other: 'Other'
    },
    longTermCancellationFriction: {
      label: 'Please type in CANCEL to confirm',
      error: 'Invalid input'
    },
    cancelHelperText: 'This action will cancel %workdays% work days and cannot be undone',
    cancel: 'Cancel All Days'
  },
  toastMessages: {
    successBulk: 'All Days Canceled',
    successSingle: 'Single Day Canceled'
  }
};
